import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import toast, { Toaster } from "react-hot-toast";

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_7w8y4ye", // Replace with your EmailJS service ID
        "template_a4cwt5r", // Replace with your EmailJS template ID
        formRef.current,
        "1IfXarriCycjWVIaC" // Replace with your public API key
      )
      .then(
        () => {
          toast.success("✅ Message sent successfully!");
          console.log("sent");
          formRef.current.reset();
        },
        (error) => {
          toast.error(error.text);
          console.log(error);
        }
      );
  };

  return (
    <section className="bg-gray-100 py-8 text-gray-800">
      <Toaster position="top" />
      <div className="max-w-6xl mx-auto px-4 space-y-12">
        {/* Heading */}
        <div className="text-center">
          <h1 className="text-3xl font-bold mb-2">Get in Touch</h1>
          <p className="text-gray-600">
            We’re here to answer your questions and provide custom quotes.
          </p>
        </div>

        {/* Grid Layout */}
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <p className="mb-4 text-semibold bg-white shadow rounded-lg p-6 text-gray-700 text-base">
              Fill out the form below if you want to place any order or have any
              general queries. We will reach out to you via mail or drop your
              <strong> phone number in the message section</strong> if you want
              to be reached out through mobile. Thank you for choosing{" "}
              <strong>Avon Tools!!</strong>
            </p>
            {/* Contact Form */}
            <form
              ref={formRef}
              onSubmit={handleSubmit}
              className="bg-white shadow rounded-lg p-6 space-y-4"
            >
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                required
                className="w-full border p-2 rounded"
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
                className="w-full border p-2 rounded"
              />
              <input
                type="text"
                name="company"
                placeholder="Your Company (optional)"
                className="w-full border p-2 rounded"
              />
              <textarea
                name="message"
                rows="4"
                placeholder="Your Message"
                required
                className="w-full border p-2 rounded"
              />
              <button
                type="submit"
                className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Contact Info & Map */}
          <div className="space-y-6">
            <div className="bg-white shadow rounded-lg p-6">
              <h2 className="text-xl font-semibold mb-2">
                Contact Information
              </h2>
              <p>
                📍 BR Plaza Complex, Palam Gurgaon Road,
                <br />
                Dundahera, Gurgaon, Haryana - 122016
              </p>
              <p className="mt-2">
                📞 +91 9818790176, +91 9871861728, +91 8383969181
              </p>
              <p>📧 avontoolsupadhyay@gmail.com</p>
              <p className="mt-2">
                GST No: <span className="font-mono">06AAKPU3829P1ZV</span>
              </p>

              <a
                href="/Avon_Tools_Brochure.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-4 bg-navy hover:bg-navy-dark text-white px-4 py-2 rounded"
              >
                📄 Download Brochure
              </a>
            </div>

            {/* Map */}
            <div className="rounded overflow-hidden shadow">
              <iframe
                title="Avon Tools Location"
                src="https://maps.google.com/maps?q=28.51532,77.077838&z=16&output=embed"
                width="100%"
                height="250"
                loading="lazy"
                style={{ border: 0 }}
                allowFullScreen=""
                referrerPolicy="no-referrer-when-downgrade"
              />
              <a
                href="https://www.google.com/maps/search/?api=1&query=28.51532,77.07783"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-sm text-navy mt-2 text-center hover:underline"
              >
                Open in Google Maps
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
